import { StadiumOutlineIcon } from './StadiumOutlineIcon';

/**
 * author: Google
 * id AB07DE31-2215-49E8-925E-8E4B235664FA
 * name stadium-outline
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/stadium-outline.svg
 * tags
 * - Sport 
 * - Places 
 */
export const ArenaOutlineIcon = StadiumOutlineIcon;
export default ArenaOutlineIcon